import TierBadge from '../components/TierBadge.jsx'
import { useDocumentTitle } from '../useDocumentTitle.js'

// The default renderer for any section with no component of its own.
//
// It exists so "not built yet" is a visible, honest state rather than a 404,
// and so the URL for a future feature is stable from today. A slot must name
// what it is waiting for; the generator refuses a `slot` section without
// `waitingOn`, so this cannot render an empty promise.
//
// Voice: one flat sentence, at most one dry follow-up. No illustration, no
// apology, no emoji — the handoff's empty-state rule.

export default function Slot({ section }) {
  useDocumentTitle(section.title)

  return (
    <article className="d2d-page">
      <header className="d2d-titleblock">
        <p className="d2d-eyebrow d2d-micro">
          <TierBadge tier={section.tier} />
        </p>
        <h1 className="d2d-titleblock__headline">{section.title}</h1>
        <p className="d2d-titleblock__lede">{section.summary}</p>
        <hr className="d2d-rule" />
      </header>
      <p className="d2d-notice" data-testid="placeholder-notice">
        Not built yet. Waiting on {section.waitingOn}.
      </p>
    </article>
  )
}
